export const RETURN_TO_PARAM = 'returnTo';

/** Accept only same-origin relative paths (blocks open redirects). */
export function safeReturnPath(raw: string | null | undefined, fallback = '/'): string {
  if (!raw?.trim()) return fallback;
  try {
    const decoded = decodeURIComponent(raw.trim());
    if (!decoded.startsWith('/') || decoded.startsWith('//')) return fallback;
    if (decoded.includes('://')) return fallback;
    return decoded;
  } catch {
    return fallback;
  }
}

export function authPathWithReturn(path: string, returnTo?: string | null): string {
  if (!returnTo?.trim()) return path;
  const safe = safeReturnPath(returnTo, '');
  if (!safe) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}${RETURN_TO_PARAM}=${encodeURIComponent(safe)}`;
}

export function locationToReturnPath(pathname: string, search = ''): string {
  const path = `${pathname}${search}`;
  return safeReturnPath(path, pathname.startsWith('/') ? pathname : '/');
}
